import { useCallback, useEffect, useState } from 'react';
import { toast } from '../../../../ui/toast'; // Assuming you are using react-toastify for notifications
import {
  deleteCandidate,
  getCandidateList,
} from '../../../../utils/api_service/candidate';
import { OrganizationUser } from '../../../../utils/types/admin_types';

export const useCandidatemanagement = () => {
  const [candidateList, setCandidateList] = useState<OrganizationUser[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false); // New loading state

  const fetchCandidates = useCallback(async () => {
    setLoading(true); // Set loading to true when starting fetch
    try {
      const response = await getCandidateList(searchTerm, pageNumber, 8);
      if (response.ok) {
        const data = await response.json();
        setCandidateList(data.candidate);
        setTotalRecords(data.numberOfCandidate);
        setTotalPages(data.pages);
      } else {
        const errorData = await response.json();
        toast.error(errorData.error, { position: 'bottom-center' });
      }
    } catch (error) {
      toast.error('Error fetching candidates: ' + error, {
        position: 'bottom-center',
      });
    } finally {
      setLoading(false); // Set loading to false after the request completes
    }
  }, [searchTerm, pageNumber]);

  useEffect(() => {
    const debounceSearchTerm = setTimeout(() => {
      fetchCandidates();
    }, 1000);

    return () => clearTimeout(debounceSearchTerm);
  }, [searchTerm, fetchCandidates]);

  useEffect(() => {
    fetchCandidates();
  }, [pageNumber, fetchCandidates]);

  // Removed duplicate handleSearchTermChange function

  const deleteUser = async (id: string) => {
    try {
      const response = await deleteCandidate(id);
      if (response.ok) {
        const updatedCandidates = candidateList.filter(
          (candidate) => candidate.id !== id,
        );
        setCandidateList(updatedCandidates);
      } else {
        const errorData = await response.json();
        toast.error(errorData.error, { position: 'bottom-center' });
      }
    } catch (error) {
      toast.error('Error deleting candidate: ' + error, {
        position: 'bottom-center',
      });
    }
  };
  const onPageChange = (page: number) => {
    setPageNumber(page);
  };
  const handleSearchTermChange = (query: string) => {
    setSearchTerm(query); // Directly set the query
    setPageNumber(1); // Reset page number to 1 when search term changes
  };

  return {
    candidateList,
    searchTerm,
    handleSearchTermChange,
    pageNumber,
    setPageNumber,
    totalPages,
    deleteUser,
    loading,
    onPageChange,
    setCandidateList,
    totalRecords,
  };
};
